import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';

const SelectCustomerHeader = ({ children, sx }) => {
    return jsx(Container, { sx: sx, children: children });
};
const Container = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    borderBottom: `1px solid ${theme.palette.ui50}`,
}));

export { SelectCustomerHeader };
//# sourceMappingURL=SelectCustomerHeader.js.map
